import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "px-10" }
const _hoisted_2 = { class: "font-size-18-600 mt-3" }
const _hoisted_3 = { class: "mt-3" }
const _hoisted_4 = { class: "font-size-14-400" }
const _hoisted_5 = { class: "mt-3" }
const _hoisted_6 = { class: "font-size-14-400" }
const _hoisted_7 = { class: "font-size-12-400 font-grey d-flex align-center card-container justify-space-between my-3" }
const _hoisted_8 = { class: "d-flex justify-space-between align-center ga-2 font-size-12-600 font-black" }
const _hoisted_9 = { class: "font-size-12-400 font-grey d-flex align-center card-container justify-space-between my-3" }
const _hoisted_10 = { class: "font-size-12-600 font-black" }
const _hoisted_11 = { class: "my-3" }
const _hoisted_12 = { class: "d-flex align-center my-3 ga-2 pt-16" }

import Icon from "@/components/Icons/Icon.vue";
import {useRoute, useRouter} from "vue-router";
import {computed, onMounted, ref} from "vue";
import CreatedBy from "@/components/custom/CreatedBy.vue";
import {healthGoalsService} from "@/api/services/healthGoals";
import RatingSlider from "@/components/custom/RatingSlider.vue";
import {useSettingsStore} from "@/api/store/settings";
import ButtonBase from "@/components/custom/ButtonBase.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ViewHealthGoals',
  setup(__props) {

const settingsStore = useSettingsStore();

const router = useRouter();
const route = useRoute();

const formState = ref({
  name: '',
  description: '',
  reason: '',
  timeframe_value: '',
  timeframe_unit: 'select',
  severity_rating: 0,
  client_visibility: true,
});

const isCompleted = computed(() => {
  return formState.value.is_complete === 'complete';
})

const isActive = computed(() => {
  return formState.value.status === 'active';
})

const fetchHealthGoal = () => {
  
  healthGoalsService.show(route.params.id).then((response) => {
    formState.value = response.data;
    
  });
}

onMounted(fetchHealthGoal)

return (_ctx: any,_cache: any) => {
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_unref(settingsStore).loading === false)
    ? (_openBlock(), _createBlock(_component_v_container, {
        key: 0,
        class: "px-0 pt-0 pb-5"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: "text-right px-4 pt-3",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push({ name: 'health-goals' })))
          }, [
            _createVNode(Icon, {
              color: "primaryColor",
              icon: "cross-icon"
            })
          ]),
          _createElementVNode("section", _hoisted_1, [
            _createVNode(CreatedBy, { icon: "practitioner-icon" }),
            _createElementVNode("h2", _hoisted_2, _toDisplayString(formState.value.name), 1),
            _createElementVNode("div", _hoisted_3, [
              _cache[2] || (_cache[2] = _createElementVNode("p", { class: "font-size-12-400 font-grey" }, "Description", -1)),
              _createElementVNode("p", _hoisted_4, _toDisplayString(formState.value.description), 1)
            ]),
            _createElementVNode("div", _hoisted_5, [
              _cache[3] || (_cache[3] = _createElementVNode("p", { class: "font-size-12-400 font-grey" }, "Why Does This Matter?", -1)),
              _createElementVNode("p", _hoisted_6, _toDisplayString(formState.value.reason), 1)
            ]),
            _createElementVNode("div", _hoisted_7, [
              _cache[4] || (_cache[4] = _createElementVNode("p", null, "Timeframe", -1)),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("p", null, _toDisplayString(formState.value.timeframe_value), 1),
                _createElementVNode("p", null, _toDisplayString(formState.value.timeframe_unit), 1)
              ])
            ]),
            _createVNode(_component_v_divider),
            _createElementVNode("div", _hoisted_9, [
              _cache[5] || (_cache[5] = _createElementVNode("p", null, "Severity rating", -1)),
              _createElementVNode("p", _hoisted_10, _toDisplayString(formState.value.severity_rating), 1)
            ]),
            _createVNode(_component_v_divider),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(RatingSlider, {
                disable: "",
                modelValue: formState.value.severity_rating,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formState.value.severity_rating) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createVNode(ButtonBase, {
                "custom-class": isCompleted.value ? 'secondary-button' : 'bg-white grey-btn text-black',
                text: isCompleted.value ? 'Completed' : 'Incomplete',
                icon: isCompleted.value ? 'thick-icon' : '',
                "color-icon": "secondary-button-color",
                disabled: "",
                width: "48%"
              }, null, 8, ["custom-class", "text", "icon"]),
              _createVNode(ButtonBase, {
                "custom-class": "white-btn text-white font-size-12-600",
                text: isActive.value ? 'Archived' : 'Active',
                icon: isActive.value ? 'archived-icon' : 'unarchived-icon',
                "color-icon": "primary-color",
                disabled: "",
                width: "48%"
              }, null, 8, ["text", "icon"])
            ])
          ])
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})